import {
  PbGetWarehouseConfigsV2Response,
  PbWarehouse,
  PbWarehouseConfig
} from '@itsrever/rever-api'
import {
  GroupRouting,
  Metadata,
  RoutingRule,
  Warehouse,
  WarehouseUpdate
} from '@/domain/warehouses'

export const toWarehouse = (warehouse: PbWarehouse): Warehouse => ({
  id: warehouse.id ?? '',
  company: warehouse.company ?? '',
  email: warehouse.email ?? '',
  firstName: warehouse.first_name ?? '',
  lastName: warehouse.last_name ?? '',
  addressLine1: warehouse.address_line1 ?? '',
  addressLine2: warehouse.address_line2 ?? '',
  city: warehouse.city ?? '',
  postcode: warehouse.postcode ?? '',
  stateProvince: warehouse.state_province ?? '',
  stateProvinceCode: warehouse.state_province_code ?? '',
  country: warehouse.country ?? '',
  countryCode: warehouse.country_code ?? '',
  phone: warehouse.phone ?? '',
  metadata: (warehouse.metadata as Metadata | undefined) ?? {}
})

export const toPbWarehouse = (
  warehouse: WarehouseUpdate,
  group: string
): PbWarehouse => ({
  id: warehouse.id || undefined,
  ecommerce_group: group,
  company: warehouse.company,
  email: warehouse.email,
  first_name: warehouse.firstName,
  last_name: warehouse.lastName,
  address_line1: warehouse.addressLine1,
  address_line2: warehouse.addressLine2,
  city: warehouse.city,
  postcode: warehouse.postcode,
  state_province: warehouse.stateProvince,
  state_province_code: warehouse.stateProvinceCode,
  country: warehouse.country,
  country_code: warehouse.countryCode.toUpperCase(),
  phone: warehouse.phone,
  ...(warehouse.metadata && { metadata: warehouse.metadata })
})

// Settings-api stores one list of options; the repeated wrapper carries a single config.
export const toRules = (configs?: PbWarehouseConfig[]): RoutingRule[] =>
  (configs ?? [])
    .flatMap((config) => config.options ?? [])
    .map((option) => ({
      warehouseId: option.warehouse_id ?? '',
      whens: option.whens ?? []
    }))

export const toPbConfigs = (rules: RoutingRule[]): PbWarehouseConfig[] => [
  {
    options: rules.map((rule) => ({
      warehouse_id: rule.warehouseId,
      whens: rule.whens
    }))
  }
]

export const toGroupRouting = (
  response: PbGetWarehouseConfigsV2Response
): GroupRouting => ({
  rules: toRules(response.warehouse_configs),
  overrides: Object.fromEntries(
    (response.overrides ?? []).map((override) => [
      override.ecommerce_id ?? '',
      toRules(override.warehouse_configs)
    ])
  )
})
